export default __webpack_public_path__ + "static/media/footer-gallery-6.80e65719.jpg";